import styled, { css } from 'styled-components';

import { rem } from '../../utils';

const iconSize = (size: 'small' | 'medium') => {
  switch (size) {
    case 'small':
      return css`
        width: ${({ theme }) => rem(theme.Icon.Size.Small)};
        height: ${({ theme }) => rem(theme.Icon.Size.Small)};
      `;
    default:
      return css`
        width: ${({ theme }) => rem(theme.Icon.Size.Large)};
        height: ${({ theme }) => rem(theme.Icon.Size.Large)};
      `;
  }
};

export const StyledWrapper = styled.a<{
  $active: boolean;
  $size?: 'small' | 'medium';
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ $size }) => ($size ? iconSize($size) : iconSize('small'))}
`;

export const StyledIconWrapper = styled(StyledWrapper)<{
  $size?: 'small' | 'medium';
}>`
  justify-content: center;
  background-color: ${({ theme }) => theme.Color.Neutrals.Light};
  border-radius: 50%;
  ${({ $size }) => ($size ? iconSize($size) : iconSize('small'))}
  border: ${({ theme }) => `${rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Light}`};
`;

export const StyledImage = styled.span<{
  $size: 'small' | 'medium';
  $sourceUrl: string | undefined;
  $variant: 'circle' | 'rounded' | 'bordered';
}>`
  ${({ $size }) => iconSize($size)}
  background-position: center center;
  background-repeat: no-repeat;
  background-color: ${({ theme }) => theme.Color.Neutrals.Paper};
  background-size: cover;
  background-image: ${({ $sourceUrl }) => `url(${$sourceUrl})`};
  border-radius: ${({ $variant, theme }) =>
    $variant === 'circle' ? '50%' : rem(theme.Border.Radius.Medium)};
  border: ${({ $variant, theme }) =>
    $variant === 'bordered'
      ? `${rem(theme.Border.Size.Small)} solid ${theme.Color.NeutralsFixed.Gray}`
      : 'none'};
`;

export const StyledInitialsContainer = styled.span`
  background-color: ${({ theme }) => theme.Color.Brand.Primary};
  display: flex;
  padding: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
